@if (!isLoading) {
<form id="templateForm" [formGroup]="templateForm" (ngSubmit)="save()" class="backlog-container">
  <div class="p-grid">
    <div class="p-col-6">
      <h6>Name</h6>
      <input pInputText name="name" type="text" formControlName="name" fluid />
    </div>
    <div class="up-col-6">
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-6">
      <h6>Subject</h6>
      <input pInputText name="subject" type="tet" formControlName="subject" fluid />
    </div>
    <div class="p-col-6">
      <h6>Title</h6>
      <input pInputText name="tile" type="text" formControlName="title" fluid />
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-12">
      <h6>Body</h6>
      <textarea pInputTextarea rows="10" name="body" formControlName="body" style="width: 100%;" fluid></textarea>
    </div>
  </div>
  <div class="p-col-12">
    <h6>Extra</h6>
    <input pInputText name="extra" type="text" formControlName="extra" fluid />
  </div>

  <p-button type="submit" severity="success" [disabled]="!templateForm.valid" label="Save">
  </p-button>
</form>
}
<div>
  @if (isLoading) {
  <span style="margin-left:8px">
    <i class="pi pi-spin pi-spinner" style="font-size: 3.5em"></i>
  </span>
  }
</div>